import { FC } from "react";
import FilterSearchField from "./FilterSearchField";
import { linkToFind } from "helpers/links-builders/listing";
import { ICityLiteAsset } from "models/Assets/ICityAsset";
import { labelHelper, trHelper } from "helpers/themeHelpers";
import useGetCountry from "hooks/useGetCountry";
import { useTheme } from "styled-components";
import useGetRouteCity from "hooks/useGetRouteCity";
import {IGoToFindParams} from "models/header";
import {isShobiddak} from "helpers/osHelpers";

interface IProps {
  onChangeQueryStringEvent?: (val: any, fieldName: string) => void;
  onChangeCityEvent?: (city: ICityLiteAsset) => void;
}



const SearchFieldBar: FC<IProps> = () => {
  const { translations } = useTheme();
  const city = useGetRouteCity();
  const currentCountry = useGetCountry();
  const searchFieldPlaceholder = isShobiddak() ? translations.header.searchInShobiddak : trHelper(translations.header.searchInCountry, {
    __country__: labelHelper(currentCountry),
  });
  const goToFindTerm = (params: IGoToFindParams) => {
    const linkToFindParams: any = { ...params };

    linkToFindParams.cities = [city];
    linkToFindParams.term = params.term ;
    document.location.href = linkToFind(linkToFindParams);
  };

  return (
    <FilterSearchField
      placeholder={searchFieldPlaceholder}
      goToFind={goToFindTerm}
    />
  );
};

export default SearchFieldBar;
